export default "__VITE_ASSET__CFYC0p7q__"